const getAverage = (grades) => {
  let total = 0,
    x,
    average;
  if (!(grades instanceof Array)) return alert("grades must be an array");
    for (x of grades) {
      total += parseInt(x);
    }
  average = total / 8;
  average += "%";
  return average;
};
export default getAverage;
